<div class="dialog-container">
  <div class="dialog-header flex_sb border-bottom">
    <div class="fs-30 fw-600" translate>{{ data?.date | uppercase }} {{ 'MONTH_BILL' | fallbackTranslate }}</div>
    <div class="flex align_center">
      <div class="dialog-header-cross" (click)="close()">
        <img [src]="images.CROSS" class="img-20" alt="close" />
      </div>
    </div>
  </div>
  <div class="dialog-form">
    <label class="select-all" nz-checkbox [(ngModel)]="allChecked" (ngModelChange)="updateAllBillChecked($event)"
      [ngModelOptions]="{ standalone: true }">
      {{ 'SELECT_ALL' | fallbackTranslate }}
    </label>
    <div class="flex flex_row align_center p-t-12 p-b-12 p-l-8 p-r-8">
      <div class="p-t-5"> 
        <mat-checkbox
         [checked]="reoccurChecked"
         (change)="reoccurCheckHandler($event)"
        >
        </mat-checkbox>
      </div> 
       <div class="m-l-10 m-t-15 m-b-10">
       <div class="flex flex_row align_center fs-14 fw-600"> {{ 'REOCCUR_TEXT' | fallbackTranslate }}    <p class="m-l-5 fs-14 fw-400 m-b-0 link-cls" (click)="openReOccurHowWorks()">{{ 'KNOW_MORE_TEXT' | fallbackTranslate }}</p></div>
       <div class="fs-14 clr-auto">{{ 'AUTO_MATIC_TEXT' | fallbackTranslate }}</div>
       </div>
     </div>
    <div class="bill-container">
      <ng-container *ngFor="let data of billInfoArr">
        <div class="bill-info" nz-checkbox [(ngModel)]="data.checked" (ngModelChange)="updateOutletChecked($event, data)"
          [ngModelOptions]="{ standalone: true }" [disabled]="billStatusText[data.status].disabled">
          <span class="left-bill-info flex">
            <img [src]="images?.ROI" width="40"
              alt="Restaurant Icon" />
            {{ data?.name }}
          </span>
          <span class="center-bill-info">{{currency}} {{ data?.amount_text }}</span>
          <span class="right-bill-info" [ngStyle]="{ color: billStatusText[data.status].color }" translate>
            {{ billStatusText[data?.status]?.text }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="footer">
    <button [disabled]="!isAtLeastOneItemChecked()" (click)="askForReocurrInfoandPay()" class="pay-button" >
      {{ 'PAY' | fallbackTranslate }}
      <span *ngIf="billToPay">
        {{currency}}: {{ billToPay }}
      </span>
    </button>
  </div>
</div>
